import React from 'react';
import { Link } from 'react-router-dom';
import { FiFacebook, FiInstagram } from 'react-icons/fi';
import { MODEL_CATEGORIES } from '../constants/shedModels';

const FooterShed = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'Browse Sheds', href: '/sheds' },
    { name: 'Contact', href: '/contact' },
    { name: 'Warranty', href: '/warranty' },
    { name: 'Dealer Login', href: '/dealer/login' },
  ];

  // Link to real category filters the inventory page understands.
  const shopLinks = MODEL_CATEGORIES.map((cat) => ({
    name: cat,
    href: `/inventory?category=${encodeURIComponent(cat)}`,
  }));

  const legalLinks = [
    { name: 'Terms & Conditions', href: '/terms-and-conditions' },
    { name: 'Privacy Policy', href: '/privacy' },
    { name: 'Refund Policy', href: '/refund-policy' },
    { name: 'Cookie Policy', href: '/cookie-policy' },
    { name: 'Disclaimer', href: '/disclaimer' },
  ];

  return (
    <footer className="bg-primary-900 text-primary-100">
      <div className="container mx-auto px-4 py-14">
        <div className="flex flex-col md:flex-row md:items-start justify-between gap-10 mb-12">
          <div className="max-w-xs">
            <Link to="/" className="inline-flex items-center mb-3">
              <img src="/logo.png" alt="Lowes Sheds" className="h-12 w-auto" />
            </Link>
            <p className="text-sm text-primary-200 leading-relaxed">
              Pre-built storage sheds, barns and studios — designed online and delivered to you. Free local delivery.
            </p>
          </div>

          <div className="flex flex-wrap gap-x-16 gap-y-8">
            <div>
              <p className="text-xs uppercase tracking-wider text-primary-300 mb-3">Pages</p>
              <ul className="space-y-2 text-sm">
                {quickLinks.map((link) => (
                  <li key={link.name}>
                    <Link to={link.href} className="text-primary-100 hover:text-white transition-colors">
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <p className="text-xs uppercase tracking-wider text-primary-300 mb-3">Shop by style</p>
              <ul className="space-y-2 text-sm">
                {shopLinks.map((link) => (
                  <li key={link.name}>
                    <Link to={link.href} className="text-primary-100 hover:text-white transition-colors">
                      {link.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            <div>
              <p className="text-xs uppercase tracking-wider text-primary-300 mb-3">Contact</p>
              <ul className="space-y-2 text-sm">
                <li><a href="tel:+16822040561" className="hover:text-white transition-colors">(682) 204-0561</a></li>
                <li><a href="mailto:info@seyardsolutions.com" className="hover:text-white transition-colors">info@seyardsolutions.com</a></li>
                <li className="text-primary-200">Mon–Sat 8am–6pm</li>
              </ul>
              <div className="flex gap-3 mt-4">
                <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="text-primary-200 hover:text-white transition-colors">
                  <FiFacebook className="w-4 h-4" />
                </a>
                <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-primary-200 hover:text-white transition-colors">
                  <FiInstagram className="w-4 h-4" />
                </a>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-primary-800 pt-6 flex flex-col md:flex-row md:items-center md:justify-between gap-4">
          <span className="text-xs text-primary-300">
            &copy; {currentYear} Lowe&apos;s Sheds &middot; SE Yard Solutions. All rights reserved.
          </span>
          <div className="flex flex-wrap gap-4 text-xs text-primary-300">
            {legalLinks.map((link) => (
              <Link key={link.name} to={link.href} className="hover:text-white transition-colors">
                {link.name}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterShed;
